module.exports = __webpack_public_path__ + "img/fanglz_ticket.e8d8c9a8.png";